<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-车辆年限-添加
    -->
  <el-dialog
    title="添加车辆年限"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
        <div class="common-form">添加车辆年限</div>
        <!-- 全分类选择 -->
        <!-- <el-form-item label="选择全分类" prop="name" >
          <div>{{ form.categorya.name }}</div>
      
        <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为车辆年限标题</el-button>
      </el-form-item> -->

        <el-form-item label="车辆年限名称" prop="name"
          ><el-input
            v-model="form.name"
            placeholder="请输入车辆年限名称"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <el-form-item label="价格" prop="price"
          ><el-input
            v-model="form.price"
            placeholder="请输入价格"
            class="max-w460"
            type="number"
          ></el-input
        ></el-form-item>

        <el-form-item label="排序" prop="name"
          ><el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <!--商品图片组件-->
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
      <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    </div>
  </el-dialog>
</template>

<script>
import Vehicle_durationApi from "@/api/vehicle_duration.js";

import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: "",
        code: "custom",
        image: [],
        // categorya:{},
        sort: 50,
        intro: "",
        bannar: []
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          { required: true, message: "请输入车辆年限名称", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    console.log(11111);
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    chooseCategory() {
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, type: "" });
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      // if (form.image.length <= 0) {
      //   self.$message({
      //     message: "请上传图片",
      //     type: "error"
      //   });
      //   return;
      // }
      // form.categorya = JSON.stringify(form.categorya );
      // form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Vehicle_durationApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    /*打开上传图片*/
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/vehicle_duration/index/part/add.vue